import { BusinessRole } from "fe-shared/src/types/domain";
import {
  CountryCode,
  Transaction,
  TransactionWarehouse,
  WarehouseTypeCode,
} from "../types/details";

const buildProcessorWarehouse = (
  targetCompanyInfo: Transaction["targetCompanyInfo"]
): TransactionWarehouse | undefined => {
  if (!targetCompanyInfo) return undefined;

  return {
    warehouseId: 0,
    signers: [],
    warehouseTypeCode: WarehouseTypeCode.ProcessingFacility,
    participant: {
      companyId: targetCompanyInfo.companyId,
      phone: targetCompanyInfo.phone ?? "",
      regNumber: targetCompanyInfo.regNumber ?? 0,
      displayName: targetCompanyInfo.displayName,
      businessRoleCode:
        (targetCompanyInfo.businessRoleCode as BusinessRole) ??
        BusinessRole.Processor,
      businessAddress: {
        addressId: targetCompanyInfo.businessAddress?.addressId ?? 0,
        countryCode:
          targetCompanyInfo.businessAddress?.countryCode ?? CountryCode.Canada,
        provinceCode: targetCompanyInfo.businessAddress?.provinceCode ?? "",
        stateCode: targetCompanyInfo.businessAddress?.stateCode ?? "",
        otherCountry: "",
        postalOrZip: targetCompanyInfo.businessAddress?.postalOrZip ?? "",
        city: targetCompanyInfo.businessAddress?.city ?? "",
        addressLine1: targetCompanyInfo.businessAddress?.addressLine1 ?? "",
        latitude: targetCompanyInfo.businessAddress?.latitude ?? 0,
        longitude: targetCompanyInfo.businessAddress?.longitude ?? 0,
      },
    },
    isCompanyActive: targetCompanyInfo.isCompanyActive ?? false,
    isActive: targetCompanyInfo.isCompanyActive ?? false,
  };
};

export default buildProcessorWarehouse;
